// extracted by mini-css-extract-plugin
module.exports = {"noResult":"style_noResult__DZnEo","recommend-item":"style_recommend-item__UKnYx","searchIcon":"style_searchIcon__Ris1m","popoverContent":"style_popoverContent__Qkrk_"};